//
// for todos, only give new code, with a bit of context
//
// TODO: add new slide just after the curren slide
import React, { useState, useEffect } from "react";
import "./presentation.css";
import { getSlide, getPresentation, setPresentation } from "../../api";

const generateSlideId = () => `slide-${crypto.randomUUID()}`;

const Presentation = () => {
  const [slides, setSlides] = useState([]);
  const [loadingSlides, setLoadingSlides] = useState({});
  const [currentSlide, setCurrentSlide] = useState(null);
  const [status, setStatus] = useState("building...");
  useEffect(() => {
    const fetchPresentation = async () => {
      try {
        const existing = await getPresentation({
          presentation_id: null,
        });
        if (existing?.data?.slides?.length) {
          setSlides(existing.data.slides);
          setCurrentSlide(existing.data.slides[0].id);
        } else {
          const initialSlideId = generateSlideId();
          setSlides([
            {
              id: initialSlideId,
              title: "&lt;title&gt;",
              data_str: "<data>",
              story: "<story>",
              input: "What do you want to know ?\nHow is skincare doing ?\nWhat is trending in Food ?",
            }
          ]);
          setCurrentSlide(initialSlideId);
        }
        setStatus("ready");
      } catch (err) {
        console.error("error:", err);
      }
    };
    fetchPresentation();
  }, []);
  const handleSelectSlide = (id) => {
    setCurrentSlide(id);
  };

  const handleUpdate = async (slide) => {
    let updatedSlides = slides;
    try {
      setStatus("updating...");
      setLoadingSlides((prev) => ({ ...prev, [slide.id]: true }));
      const data = await getSlide({ input: slide.input });
      updatedSlides = slides.map((s) => {
        return s.id === slide.id
          ? {
              ...s,
              story: data.story,
              data: data.data,
              data_str: data.data_str,
              title: data.title,
              title_simple: data.title_simple,
              exc_str: data.exc_str,
              query_str: data.query_str,
              reasoning: data.reasoning,
            }
          : s;
      });
      setSlides(updatedSlides);
    } catch (error) {
      console.error("error:", error);
    } finally {
      setLoadingSlides((prev) => {
        const updated = { ...prev, [slide.id]: false };
        const allDone = Object.values(updated).every((v) => v === false);
        if (allDone) {
          (async () => {
            // setStatus("saving...");
            // wait until all React state updates are flushed before saving
            await new Promise((resolve) => setTimeout(resolve, 100));
            await setPresentation({
              presentation_id: null,
              slides: updatedSlides,
            });
            setStatus("ready");
          })();
        }
        return updated;
      });
    }
  };

  const handleNewSlide = async () => {
    const slide_id = generateSlideId();
    setSlides((prevSlides) => {
      const currentIndex = prevSlides.findIndex((s) => s.id === currentSlide);
      const insertIndex = currentIndex >= 0 ? currentIndex + 1 : prevSlides.length;
      const newSlide = {
        id: slide_id,
      };
      const updated = [
        ...prevSlides.slice(0, insertIndex),
        newSlide,
        ...prevSlides.slice(insertIndex),
      ];
      return updated;
    });
    // we'll set currentSlide in a separate effect to ensure state consistency
    setTimeout(() => {
      setCurrentSlide(slide_id);
    }, 0);
  };
  return (
    <div id="slides">
      <div id="left">
        <div id="small_slides">
          {slides.map((slide) => (
            <div className="small_slide_wrapper" key={slide.id}>
              <div className="small_slide_controls">
                <button
                  className="arrow up"
                  onClick={() => {
                    setSlides((prev) => {
                      const index = prev.findIndex((s) => s.id === slide.id);
                      if (index > 0) {
                        const newSlides = [...prev];
                        const temp = newSlides[index - 1];
                        newSlides[index - 1] = newSlides[index];
                        newSlides[index] = temp;
                        return newSlides;
                      }
                      return prev;
                    });
                  }}
                >
                  ↑
                </button>
                <button
                  className="arrow down"
                  onClick={() => {
                    setSlides((prev) => {
                      const index = prev.findIndex((s) => s.id === slide.id);
                      if (index < prev.length - 1) {
                        const newSlides = [...prev];
                        const temp = newSlides[index + 1];
                        newSlides[index + 1] = newSlides[index];
                        newSlides[index] = temp;
                        return newSlides;
                      }
                      return prev;
                    });
                  }}
                >
                  ↓
                </button>
              </div>
              <button
                className={`slide_small ${currentSlide === slide.id ? "active focused" : ""}`}
                onClick={() => handleSelectSlide(slide.id)}
              >
                {loadingSlides[slide.id] ? "Updating..." : slide.id}
              </button>
            </div>
          ))}
        </div>
        <button className="slide_new" onClick={handleNewSlide}>
          New Slide
        </button>
        <div className="spacer"></div>
        <button
          onClick={async () => {
            setStatus("updating all...");
            await Promise.all(slides.map((slide) => handleUpdate(slide)));
          }}
        >
          Update All
        </button>
        <button
          onClick={async () => {
            setStatus("saving...");
            try {
              await setPresentation({
                presentation_id: null,
                slides,
              });
              setStatus("ready");
            } catch (err) {
              console.error("Save error:", err);
              setStatus("error saving");
            }
          }}
        >
          Save
        </button>
        <p id="status">{status}</p>
      </div>
      <div id="center">
        {slides.map((slide) => {
          return (
            <div
              key={slide.id}
              className={`slide_big ${currentSlide === slide.id ? "" : "hidden"}`}
            >
              <p
                className="title"
                dangerouslySetInnerHTML={{ __html: slide.title ?? "&lt;title&gt;" }}
              ></p>
              <div className="data_story">
                <p className="story">{slide.exc_str ?? slide.story ?? "<story>"}</p>
                <p className="data">{slide.data_str ?? "<data>"}</p>
                <p className="reasoning">{slide.reasoning ?? "<reasoning>"}</p>
              </div>
              <div className="input_wrapper">
                <textarea
                  className="input"
                  value={slide.input}
                  onChange={(e) => {
                    const newInput = e.target.value;
                    setSlides((prevSlides) =>
                      prevSlides.map((s) => (s.id === slide.id ? { ...s, input: newInput } : s))
                    );
                  }}
                />
                <button
                  className="input_button"
                  disabled={!!loadingSlides[slide.id]}
                  onClick={() => handleUpdate(slide)}
                >
                  {loadingSlides[slide.id] ? "Updating..." : "Update"}
                </button>
                <p className="query">{slide.query_str ?? "<query>"}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Presentation;
